var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { styleBlock } from "../styleBlock";
const InputPhone = (_a) => {
    var { prefixList, className, feedbackValid, feedbackInvalid, onChange, prefixLabel, suffixLabel, prefixControlId, suffixControlId } = _a, inputProps = __rest(_a, ["prefixList", "className", "feedbackValid", "feedbackInvalid", "onChange", "prefixLabel", "suffixLabel", "prefixControlId", "suffixControlId"]);
    const [value, setValue] = useState({
        prefix: "",
        suffix: "",
        focused: false,
    });
    useEffect(() => {
        if (inputProps.value) {
            const valueString = `${inputProps.value}`;
            if (inputProps.value[0] === "+") {
                setValue(Object.assign(Object.assign({}, value), { prefix: valueString.substr(0, 4), suffix: valueString.substr(4) }));
            }
            else {
                setValue(Object.assign(Object.assign({}, value), { prefix: prefixList ? prefixList[0] : "", suffix: valueString }));
            }
        }
    }, [inputProps.value]);
    const b = styleBlock("input-phone");
    function handleChange(e) {
        if (e.target.name === "suffix") {
            e.target.value = e.target.value.replace(/[\D]*/g, "");
        }
        const newValue = Object.assign(Object.assign({}, value), { [e.target.name]: e.target.value });
        setValue(newValue);
        if (onChange) {
            onChange(newValue.suffix ? newValue.prefix + newValue.suffix : undefined);
        }
    }
    function handleFocus() {
        setValue(Object.assign(Object.assign({}, value), { focused: true }));
    }
    function handleBlur() {
        setValue(Object.assign(Object.assign({}, value), { focused: false }));
    }
    return (React.createElement(Form.Row, { className: b.toString() + " " + className },
        React.createElement("div", { className: b("container")
                .mix(!!feedbackInvalid && "is-invalid")
                .mix(value.focused && "focus") },
            React.createElement(Form.Group, { controlId: prefixControlId },
                React.createElement(Form.Label, { srOnly: true }, prefixLabel),
                React.createElement(Form.Control, { id: prefixControlId, name: "prefix", custom: true, as: "select", value: value.prefix, onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur }, prefixList === null || prefixList === void 0 ? void 0 : prefixList.map((prefix, index) => (React.createElement("option", { value: prefix, key: index }, prefix))))),
            React.createElement(Form.Group, { controlId: suffixControlId },
                React.createElement(Form.Label, { srOnly: true }, suffixLabel),
                React.createElement(Form.Control, { id: suffixControlId, name: "suffix", value: value.suffix, type: "phone", onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur }))),
        feedbackValid && React.createElement(Form.Control.Feedback, null, feedbackValid),
        feedbackInvalid && React.createElement(Form.Control.Feedback, { type: "invalid" }, feedbackInvalid)));
};
InputPhone.defaultProps = {
    prefixList: ["+420", "+421"],
};
export default InputPhone;
//# sourceMappingURL=index.js.map